import { ref } from 'vue';

export function useContactForm() {
  const isSubmitting = ref(false);
  const showSuccess = ref(false);
  const showError = ref(false);

  // Base URL for the API for both development and production
  const apiBaseUrl =
    import.meta.env.VITE_API_BASE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000');

  const handleSubmit = async e => {
    e.preventDefault();

    if (isSubmitting.value) return;

    isSubmitting.value = true;
    showError.value = false;
    showSuccess.value = false;

    const form = e.target;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData);

    try {
      // Use relative URL that works on any domain
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error('Failed to send email');

      form.reset();
      showSuccess.value = true;
      setTimeout(() => {
        showSuccess.value = false;
      }, 3000);
    } catch (error) {
      console.error('Email Error:', error);
      showError.value = true;
    } finally {
      isSubmitting.value = false;
    }
  };

  return {
    isSubmitting,
    showSuccess,
    showError,
    handleSubmit
  }
}